export default __webpack_public_path__ + "static/featured_properties3-dacb3d73b26482603906f4ddd9a4f802.png";